import { Circle, GitBranch } from "react-feather";

export default [
	// {
	// 	header: "Нэмэлт",
	// },
	// {
	// 	id: "finance",
	// 	title: "Санхүү",
	// 	icon: <i className="far fa-balance-scale"></i>,
    //     children: [
    //         {
	// 			id: "salary-info",
	// 			title: "Цалингийн мэдээлэл",
	// 			icon: <Circle size={12} />,
	// 			navLink: "/finance/information",
	// 		},
	// 		// {
	// 		// 	id: "asset-info",
	// 		// 	title: "Эд хөрөнгийн жагсаалт",
	// 		// 	icon: <Circle size={12} />,
	// 		// 	navLink: "/finance/stock",
	// 		// },
    //     ]
    // },
    // {
	// 	id: "hr",
	// 	title: "Хүний нөөц",
	// 	icon: <i className="fal fa-user-clock"></i>,
    //     children: [
    //         {
	// 			id: "toiroh",
	// 			title: "Тойрох",
	// 			icon: <Circle size={12} />,
	// 			navLink: "/cards/analytics",
	// 		},
    //     ]
    // },
	{
		id: "complaint",
		title: "Өргөдөл, хүсэлт ",
		icon: <GitBranch size={20} />,
		children: [
			{
				id: "complaint2",
				title: "Өргөдөл",
				icon: <Circle size={12} />,
				navLink: "/request/complaint",
			},
			{
				id: "complaint3",
				title: "Дүнгийн дүйцүүлэлт",
				icon: <Circle size={12} />,
				navLink: "/request/correspond",
			},
			{
				id: "complaint4",
				title: "Чөлөөний хүсэлт",
				icon: <Circle size={12} />,
				navLink: "/request/leave",
			},
			{
				id: "complaint5",
				title: "Тойрох хуудас",
				icon: <Circle size={12} />,
				navLink: "/request/routingslip",
			},
		],
	},
	// {
	// 	id: "public",
	// 	title: "Багшийн туслах",
	// 	icon: <Circle size={12} />,
	// 	navLink: "request/tutor",
	// },
]
